import { render } from "./RuleApprovalForm.vue?vue&type=template&id=cc4f651a"
import script from "./RuleApprovalForm.vue?vue&type=script&lang=js"
export * from "./RuleApprovalForm.vue?vue&type=script&lang=js"

import "./RuleApprovalForm.vue?vue&type=style&index=0&id=cc4f651a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/RuleApprovalForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc4f651a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc4f651a', __exports__)) {
    api.reload('cc4f651a', __exports__)
  }
  
  module.hot.accept("./RuleApprovalForm.vue?vue&type=template&id=cc4f651a", () => {
    api.rerender('cc4f651a', render)
  })

}


export default __exports__